import React from 'react';
import { connect } from 'react-redux';
import NotAuthorized from './MNotAuthorized';
import UserStatus from '../../menus/users/MStatus';
import ResetPassword from '../../menus/users/MResetPassword';
import UserDelete from '../../menus/users/MDeleteItem';
import RoleDelete from '../../menus/roles/MDeleteItem';
import RppFileDelete from '../../menus/_features/rpp/MDeleteFile';
import RppDelete from '../../menus/_features/rpp/MDeleteItem';
import MateriViewDetailNotif from '../../menus/_features/materi/MViewDetailNotif';
import MateriDeleteNotif from '../../menus/_features/materi/MDeleteNotif';
import MateriFileDelete from '../../menus/_features/materi/MDeleteFile';
import MateriDelete from '../../menus/_features/materi/MDeleteItem';
import TugasSummaryAnswer from '../../menus/_features/tugas/MViewSummaryAnswer';
import TugasPublishStudentScore from '../../menus/_features/tugas/MPublishStudentScore';
import TugasUnpublishStudentScore from '../../menus/_features/tugas/MUnpublishStudentScore';
import TugasShareAnswerKey from '../../menus/_features/tugas/MShareAnswerKey';
import TugasViewItemCopy from '../../menus/_features/tugas/MViewItemCopy';
import TugasViewDetailNotif from '../../menus/_features/tugas/MViewDetailNotif';
import TugasDeleteShareAnswerKey from '../../menus/_features/tugas/MDeleteShareAnswerKey';
import TugasSyncScore from '../../menus/_features/tugas/MSyncScore';
import TugasDeleteImage from '../../menus/_features/tugas/MDeleteImage';
import TugasDeleteNotif from '../../menus/_features/tugas/MDeleteNotif';
import TugasDelete from '../../menus/_features/tugas/MDeleteItem';
import TugasDeleteStudentAnswer from '../../menus/_features/tugas/MDeleteStudentAnswer';
import TugasDeleteAllStudentAnswer from '../../menus/_features/tugas/MDeleteStudentAnswerAll';
import TugasDeleteSyncScore from '../../menus/_features/tugas/MDeleteSyncScore';
import LatihanViewItemCopy from '../../menus/_features/latihan/MViewItemCopy';
import LatihanViewDetailNotif from '../../menus/_features/latihan/MViewDetailNotif';
import LatihanDeleteNotif from '../../menus/_features/latihan/MDeleteNotif';
import LatihanDeleteImage from '../../menus/_features/latihan/MDeleteImage';
import LatihanDelete from '../../menus/_features/latihan/MDeleteItem';
import TesSummaryAnswer from '../../menus/_features/tes/MViewSummaryAnswer';
import TesPublishStudentScore from '../../menus/_features/tes/MPublishStudentScore';
import TesUnpublishStudentScore from '../../menus/_features/tes/MUnpublishStudentScore';
import TesShareAnswerKey from '../../menus/_features/tes/MShareAnswerKey';
import TesViewItemCopy from '../../menus/_features/tes/MViewItemCopy';
import TesViewDetailNotif from '../../menus/_features/tes/MViewDetailNotif';
import TesDeleteShareAnswerKey from '../../menus/_features/tes/MDeleteShareAnswerKey';
import TesSyncScore from '../../menus/_features/tes/MSyncScore';
import TesDeleteNotif from '../../menus/_features/tes/MDeleteNotif';
import TesDeleteImage from '../../menus/_features/tes/MDeleteImage';
import TesDelete from '../../menus/_features/tes/MDeleteItem';
import TesDeleteStudentAnswer from '../../menus/_features/tes/MDeleteStudentAnswer';
import TesDeleteAllStudentAnswer from '../../menus/_features/tes/MDeleteStudentAnswerAll';
import TesDeleteSyncScore from '../../menus/_features/tes/MDeleteSyncScore';
import MonitoringEventView from '../../menus/_features/monitoring/MViewEvent';
import MonitoringNoteView from '../../menus/_features/monitoring/MViewNote';
import MonitoringPesanView from '../../menus/_features/monitoring/MViewPesan';
import MonitoringBlockView from '../../menus/_features/monitoring/MViewBlock';
import CbtparticipantEdit from '../../menus/_features/cbt/participant/MEdit';
import CbtDeleteImage from '../../menus/_features/cbt/question/MDeleteImage';
import CbtquestionDeleteCbtparticipantAnswer from '../../menus/_features/cbt/question/MDeleteCbtparticipantAnswer';
import CbtquestionDeleteCbtparticipantAllAnswer from '../../menus/_features/cbt/question/MDeleteCbtparticipantAllAnswer';
import CbtparticipantDelete from '../../menus/_features/cbt/participant/MDeleteItem';
import CbtquestionDelete from '../../menus/_features/cbt/question/MDeleteItem';
import CbtquestionSummaryAnswer from '../../menus/_features/cbt/question/MViewSummaryAnswer';
import CalendarViewEvent from '../../menus/_features/calendar/MViewEvent';
import CalendarDeleteEvent from '../../menus/_features/calendar/MDeleteEvent';
import CalendarDelete from '../../menus/_features/calendar/MDeleteItem';
import CalendarStatus from '../../menus/_features/calendar/MSetActive';
import PesanPreview from '../../menus/_features/pesanpribadi/MPreview';
import PesanInfoAdd from '../../menus/_features/pesanpribadi/MInfoAdd';
import PesanFileDelete from '../../menus/_features/pesanpribadi/MDeleteFile';
import PesanDelete from '../../menus/_features/pesanpribadi/MDeleteItem';
import SlideshowDelete from '../../menus/_features/slideshow/MDeleteItem';
import AnnouncementFileDelete from '../../menus/_features/announcement/MDeleteFile';
import AnnouncementDelete from '../../menus/_features/announcement/MDeleteItem';
import WhatsappPreview from '../../menus/_features/whatsapp/MPreview';
import WhatsappFileDelete from '../../menus/_features/whatsapp/MDeleteFile';
import WhatsappDelete from '../../menus/_features/whatsapp/MDeleteItem';
import WhatsappSettingPopup from '../../menus/_features/whatsapp/MSettingPopup';
import PortaluserPesanDelete from '../../menus/_features/portaluser/MDeletePesanItem';
import PortaluserDeleteAll from '../../menus/_features/portaluser/MDeleteAllPortalusers';
import ReportnotifDelete from '../../menus/_features/reportnotif/MDeleteItem';
import JenjangStatus from '../../menus/_features/jenjang/MStatus';
import JenjangDelete from '../../menus/_features/jenjang/MDeleteItem';
import TingkatStatus from '../../menus/_features/tingkat/MStatus';
import TingkatDelete from '../../menus/_features/tingkat/MDeleteItem';
import KelasStatus from '../../menus/_features/kelas/MStatus';
import KelasDelete from '../../menus/_features/kelas/MDeleteItem';
import PelajaranStatus from '../../menus/_features/pelajaran/MStatus';
import PelajaranDelete from '../../menus/_features/pelajaran/MDeleteItem';
import YearStatus from '../../menus/_features/year/MStatus';
import YearDelete from '../../menus/_features/year/MDeleteItem';
import SemDelete from '../../menus/_features/sem/MDeleteItem';
import PopUpImageModal from '../common/layout/MImagePopup';
import PopUpPdfModal from '../common/layout/MPdfPopup';
import TestModal from '../../menus/tests/ModalTest';
/* Modal Error */
import ModalError from './MError';

const modalLookup = {
  NotAuthorized,
  UserStatus,
  ResetPassword,
  UserDelete,
  RoleDelete,
  RppFileDelete,
  RppDelete,
  MateriViewDetailNotif,
  MateriDeleteNotif,
  MateriFileDelete,
  MateriDelete,
  TugasSummaryAnswer,
  TugasPublishStudentScore,
  TugasUnpublishStudentScore,
  TugasShareAnswerKey,
  TugasViewItemCopy,
  TugasViewDetailNotif,
  TugasDeleteShareAnswerKey,
  TugasSyncScore,
  TugasDeleteNotif,
  TugasDeleteImage,
  TugasDeleteStudentAnswer,
  TugasDeleteAllStudentAnswer,
  TugasDelete,
  TugasDeleteSyncScore,
  LatihanViewItemCopy,
  LatihanViewDetailNotif,
  LatihanDeleteNotif,
  LatihanDeleteImage,
  LatihanDelete,
  TesSummaryAnswer,
  TesPublishStudentScore,
  TesUnpublishStudentScore,
  TesShareAnswerKey,
  TesViewItemCopy,
  TesViewDetailNotif,
  TesDeleteShareAnswerKey,
  TesSyncScore,
  TesDeleteNotif,
  TesDeleteImage,
  TesDeleteStudentAnswer,
  TesDeleteAllStudentAnswer,
  TesDeleteSyncScore,
  TesDelete,
  MonitoringEventView,
  MonitoringNoteView,
  MonitoringPesanView,
  MonitoringBlockView,
  CbtparticipantEdit,
  CbtDeleteImage,
  CbtquestionSummaryAnswer,
  CbtparticipantDelete,
  CbtquestionDelete,
  CbtquestionDeleteCbtparticipantAnswer,
  CbtquestionDeleteCbtparticipantAllAnswer,
  CalendarViewEvent,
  CalendarDeleteEvent,
  CalendarDelete,
  CalendarStatus,
  PesanFileDelete,
  PesanDelete,
  PesanPreview,
  PesanInfoAdd,
  SlideshowDelete,
  AnnouncementFileDelete,
  AnnouncementDelete,
  WhatsappPreview,
  WhatsappFileDelete,
  WhatsappDelete,
  WhatsappSettingPopup,
  PortaluserPesanDelete,
  PortaluserDeleteAll,
  ReportnotifDelete,
  JenjangStatus,
  JenjangDelete,
  TingkatStatus,
  TingkatDelete,
  KelasStatus,
  KelasDelete,
  PelajaranStatus,
  PelajaranDelete,
  YearStatus,
  YearDelete,
  SemDelete,
  PopUpImageModal,
  PopUpPdfModal,
  TestModal,
  ModalError,
};

const mapState = (state) => ({
  currentModal: state.modals,
});

const ModalManager = ({ currentModal }) => {
  let renderedModal;

  if (currentModal) {
    const { modalType, modalProps } = currentModal;

    const ModalComponent = modalLookup[modalType];

    if (ModalComponent) {
      renderedModal = <ModalComponent {...modalProps} />;
    } else {
      console.warn(`Modal "${modalType}" is not registered.`);
      const ModalError = modalLookup['ModalError'];
      /* Error Modal has not registered => show generic error modal */
      renderedModal = <ModalError modalName={modalType} />;
    }
  }
  return <span>{renderedModal}</span>;
};

export default connect(mapState)(ModalManager);
